// extracted by mini-css-extract-plugin
module.exports = {"root":"SEOCopyParagraph_root__bsjrs","title":"SEOCopyParagraph_title__3W4Pf","text":"SEOCopyParagraph_text__jXPbs"};